import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import PMHome from '../../components/projectmanager/new/PMHome';

class PMHomeContainer extends Component {
	render() {
		return (
			<PMHome {...this.props} />
		);
	}
}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {

	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMHome);


// WEBPACK FOOTER //
// ./src/containers/projectmanager/PMHomeContainer.js